var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 116,
    viewBox: "0 0 167 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3612 1.85766L4.84249 27.0616C3.473 27.5465 2.28748 28.4441 1.4495 29.6309C0.611514 30.8176 0.162317 32.2351 0.163615 33.6879L0.137585 108.343C0.136659 109.465 0.40458 110.571 0.918845 111.568C1.43311 112.565 2.17889 113.425 3.09354 114.074C4.00819 114.724 5.06513 115.145 6.17598 115.302C7.28682 115.46 8.41921 115.348 9.47825 114.978L76.3957 91.5923C80.1526 90.2826 84.2371 90.2826 88.0026 91.5923L154.558 114.961C155.618 115.333 156.751 115.445 157.863 115.289C158.975 115.133 160.033 114.712 160.949 114.062C161.865 113.412 162.611 112.552 163.126 111.554C163.641 110.556 163.909 109.449 163.907 108.326L163.864 33.55C163.864 30.5772 161.986 27.9233 159.177 26.9323L88.0283 1.85766C84.2542 0.530686 80.1354 0.530686 76.3612 1.85766",
    fill: "#70BDE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.821 100.381L166.372 101.329L164.821 100.381Z",
    fill: "#B22E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.ac3a24360796f50e776ce2a7012c199b.svg";
export { ForwardRef as ReactComponent };